import { ProductCategory, ProductUseType } from '../enums/product.enum';

export interface ProductDTO {
    id?: number;
    productCode: string;
    productName: string;
    category: ProductCategory;
    useType: ProductUseType;
    price: number;       // 판매가
    costPrice?: number;  // 원가(선택)
    isActive: boolean;   // 사용여부
}

export class ProductDTO {
    id?: number;
    productCode: string = '';
    productName: string = '';
    category: ProductCategory = null;
    useType: ProductUseType = null;
    price: number = 0;
    costPrice?: number = 0;
    isActive: boolean = true;

    constructor(data?: Partial<ProductDTO>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

/** 검색 파라미터 */
export class ProductSearchDTO {
    keyword?: string;       // 코드/이름 검색
    category?: ProductCategory | '';
    useType?: ProductUseType | '';
    isActive?: boolean | ''; // ''=전체
    minPrice?: number;
    maxPrice?: number;
    page?: number = 1;
    rows?: number = 10;

    constructor(data?: Partial<ProductSearchDTO>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}